var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.58333C2.5 3.4325 3.4325 2.5 4.58333 2.5H15.4167C16.5675 2.5 17.5 3.4325 17.5 4.58333V15.4167C17.5 16.5675 16.5675 17.5 15.4167 17.5H4.58333C3.4325 17.5 2.5 16.5675 2.5 15.4167V4.58333ZM4.58333 4.16667C4.35333 4.16667 4.16667 4.35333 4.16667 4.58333V12.155L6.66667 9.655L9.16667 12.155L13.3333 7.98833L15.8333 10.4883V4.58333C15.8333 4.35333 15.6467 4.16667 15.4167 4.16667H4.58333ZM15.8333 12.845L13.3333 10.345L9.16667 14.5117L6.66667 12.0117L4.16667 14.5117V15.4167C4.16667 15.6467 4.35333 15.8333 4.58333 15.8333H15.4167C15.6467 15.8333 15.8333 15.6467 15.8333 15.4167V12.845ZM8.125 5.83333C7.32 5.83333 6.66667 6.48667 6.66667 7.29167C6.66667 8.09667 7.32 8.75 8.125 8.75C8.93 8.75 9.58333 8.09667 9.58333 7.29167C9.58333 6.48667 8.93 5.83333 8.125 5.83333Z",
    fill: "#8B93A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.7db5f58dbb87a60312ece74d69c45d8e.svg";
export { ForwardRef as ReactComponent };